export default {
    LOADFEEDS: 'LOADFEEDS',
    LOADBUSINESS: 'LOADBUSINESS',
    LOADUSERHISTORY: 'LOADUSERHISTORY',
    LOADBUSINESSDETAIL: 'LOADBUSINESSDETAIL',
    TITLEFOOTER: 'TITLEFOOTER',
    SENDBUTTON: 'SENDBUTTON',
    TITLEHEADER: 'TITLEHEADER',
    WITHQRFOOTER: 'WITHQRFOOTER',
    WITHQRHEADER: 'WITHQRHEADER',
    ADDBUSINESS: 'ADDBUSINESS',
    LOADCATEGORY: 'LOADCATEGORY',
    ADDFOLLOWER: 'ADDFOLLOWER',
    LOADPROFILEFEEDS: 'LOADPROFILEFEEDS'
}